import styled from 'styled-components';
import { Box } from '../CommonComponents/OPL/Box/Box';

export const ContentWrapper = styled(Box)({
  height: 'min(240px, 30vh)',
  overflowY: 'auto',
  padding: '0 24px 24px',
});
